<template>
  <div class="header-w">
    <div class="logo"></div>
    <ul class="tab-w" >
      <li class="tab-l" v-for="(i,key) in tabs" :key="key" @click="clickTab(i)" :class="{'teb-sel': activated === i.to}">
        <!-- <router-link class="tab" :to="i.to" >{{i.title}}</router-link> -->{{i.title}}
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'vheader',
  data () {
    return {
      activated: '',
      tabs: [
        {title: '首页', to: '/'},
        {title: '关于我们', to: '/about'},
        {title: '技术创新', to: '/tech'},
        {title: '产品介绍', to: '/product'},
        {title: '新闻资讯', to: '/news'},
        {title: '联系我们', to: '/contact'}
      ]
    }
  },
  watch: {
    $route (to, from) {
      this.activated = to.path
    }
  },
  mounted () {
    this.activated = this.$route.path
  },
  methods: {
    clickTab (i) {
      this.activated = i.to
      this.$router.push(i.to)
    }
  }
}
</script>
<style scoped>
  .header-w{
    width: 100%;
    height: 100px;
    position: relative;
  }
  .logo{
    position: absolute;
    left: 18%;
    top: 22px;
    width: 214px;
    height: 54px;
    background: url('../../assets/img/vheader/logo_t.png');
    background-size: 100%;
  }
  .tab-w{
    position: absolute;
    top: 29px;
    right: 18%;
    width: 35%;
    height: 40px;
    display: flex;
    justify-content: center;
  }
  .tab-l{
    flex: auto;
    width: 100px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #001A5C;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
  }
  .teb-sel{
    background: #31B5FF;
    color: #fff;
    border-radius: 10px;
  }
  li, ul {
    list-style: none;
}
</style>



// WEBPACK FOOTER //
// src/components/lib/vheader.vue